import { useState } from 'react'
import { ContainerDragAndDropImage } from './styles'

export function InputDragAndDrop({ setImage, image }) {
  const [dragging, setDragging] = useState(false)

  const handleDragEnter = (e) => {
    e.preventDefault()
    setDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setDragging(true)

    const files = e.dataTransfer.files
    const filesArray = Array.from(files)
    setImage(filesArray[0])

    // Obter os arquivos soltos
  }

  const handleImages = (e) =>  {
    const files = e.target.files
    const filesArray = Array.from(files)
    setImage(filesArray[0])
  }

  return (
    <ContainerDragAndDropImage
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      dragging={dragging}
      htmlFor="files"
    >
      <input
        id="files"
        name="files"
        type="file"
        multiple
        onChange={handleImages}
        style={{
          display: 'none',
        }}
      />
      {!image && (
        <>
          <p>Escolha a imagem que deseja colocar no banner da home</p>
          <p>Ou arraste e solte a imagem aqui</p>
          <p>Formatos suportados: .jpg, .jpeg, .png</p>
        </>
      )}
      {image && <p>{image.name}</p>}

    </ContainerDragAndDropImage>
  )
}
